import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Ishan Berry </span>
            from <span className="purple"> Agra, India.</span>
            <br /> I am a pre final year student pursuing BTech 
             Computer Science at GLA Univeristy Mathura.
            <br />
            
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> I enjoy enriching my knowledge by avidly reading a diverse array of topics on Wikipedia, fostering a deep interest in a broad range of subjects
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Ishan</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
